import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// AntD v5 static methods (Modal.confirm, message.*, notification.*) silently
// no-op on React 19 without this patch. Must be imported before any AntD use.
import '@ant-design/v5-patch-for-react-19';
import '@styles/global.css';
// i18n must initialize before any component reads a translation.
import './i18n';
import { App } from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
